import React from "react";
import { useTheme, useMediaQuery } from '@mui/material';

interface ImageWithTextProps {
  src: string;
  alt: string;
}

const ImgResponsive: React.FC<ImageWithTextProps> = ({ src, alt }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));


  const lastIndex = src.lastIndexOf('/');

  const webSrc =
    lastIndex !== -1
      ? src.slice(0, lastIndex) + '/Desk-' + src.slice(lastIndex + 1)
      : src;

  return (
    <img
      src={isMobile ? src : webSrc}
      alt={alt}
      style={{ width: '100%', height: 'auto', borderRadius: '10px' }}
      loading='lazy'
    />
  );
};

export default ImgResponsive;